var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos-last-contact-access p-3",attrs:{"no-body":""}},[_c('bpc-pos-contact-summary',{attrs:{"contact":_vm.lastContactAccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }